const statusOf = (error) => (typeof error?.status === 'number' ? error.status : undefined);

const functionStatusOf = (error) =>
  typeof error?.context?.status === 'number' ? error.context.status : undefined;

export const forceLocalSignOut = async (auth) => {
  // Supabase does not expose a public offline-only cleanup operation. Keep the
  // private fallback confined here and covered by tests.
  // eslint-disable-next-line no-underscore-dangle
  await auth._removeSession();
  // eslint-disable-next-line no-underscore-dangle
  await auth._notifyAllSubscribers('SIGNED_OUT', null);
};

export const signOutLocally = async (auth) => {
  let remoteError = null;
  try {
    const { error } = await auth.signOut({ scope: 'local' });
    remoteError = error;
  } catch (error) {
    remoteError = error;
  }

  if (remoteError) await forceLocalSignOut(auth);

  return remoteError;
};

/** Distinguishes a dead session from a real permission error without parsing messages. */
export const probeFunctionSession = async (auth, functionError) => {
  const functionStatus = functionStatusOf(functionError);
  if (functionStatus === 401) return 'invalid';
  if (functionStatus !== 403) return 'not-applicable';

  try {
    const { data, error } = await auth.getUser();
    if (!error) return data.user ? 'valid' : 'invalid';

    const authStatus = statusOf(error);
    return authStatus !== undefined && authStatus >= 400 && authStatus < 500 ? 'invalid' : 'unavailable';
  } catch {
    return 'unavailable';
  }
};
